import * as tslib_1 from "tslib";
import { OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';
import { environment } from '@environments/environment';
import Auth from '@aws-amplify/auth';
import { AuthUtil, AuthService } from '@examsoft/es-login';
import { LayoutState, CloseMenu, OpenMenu, OpenTimer } from '../../store';
var NavComponent = /** @class */ (function () {
    function NavComponent(authService, authUtil, route, router, store) {
        var _this = this;
        this.authService = authService;
        this.authUtil = authUtil;
        this.route = route;
        this.router = router;
        this.store = store;
        this.auth = this.authService.user$.subscribe(function (data) {
            _this.fullName = data.given_name + " " + data.family_name;
            _this.isAdmin = authService.isAdmin();
        });
    }
    NavComponent.prototype.closeNav = function (event) {
        this.store.dispatch(new CloseMenu());
        event.stopPropagation();
    };
    NavComponent.prototype.openNav = function (event) {
        this.store.dispatch(new OpenMenu());
        event.stopPropagation();
    };
    NavComponent.prototype.showTimer = function () {
        this.store.dispatch(new OpenTimer());
    };
    NavComponent.prototype.signOut = function () {
        this.store.dispatch(new CloseMenu());
        this.logout();
    };
    NavComponent.prototype.logout = function () {
        var domain = environment.aws.oauth.domain;
        var clientId = environment.aws.Auth.userPoolWebClientId;
        var logout = environment.esLogin;
        var url = "https://" + domain + "/logout?client_id=" + clientId + "&logout_uri=" + logout;
        Auth.signOut().then(function () {
            window.location.href = url;
        });
    };
    NavComponent.prototype.ngOnDestroy = function () {
        this.auth.unsubscribe();
    };
    tslib_1.__decorate([
        Select(LayoutState.getShowMenu),
        tslib_1.__metadata("design:type", Observable)
    ], NavComponent.prototype, "showMenu$", void 0);
    return NavComponent;
}());
export { NavComponent };
